enum BillingsTaxiUnbilledPrivateOrderListingSortKey {
  START_DATE_ASC = "START_DATE_ASC",
  START_DATE_DESC = "START_DATE_DESC",
  INTERNAL_ORDER_ID_ASC = "INTERNAL_ORDER_ID_ASC",
  INTERNAL_ORDER_ID_DESC = "INTERNAL_ORDER_ID_DESC",
}

export default BillingsTaxiUnbilledPrivateOrderListingSortKey;
